// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__2LHEq","image":"recipe_image__2DLQU"};